/**
 * Envío PJ-2 · «Personalización del proyecto»: primeras opciones del menú del
 * proyecto. Muestra la marca, el reparto y la plantilla que usa el proyecto
 * abierto; cada fila abre dónde se cambia (Biblioteca o Plantillas).
 * Se consulta al abrir el menú (sin sondeos).
 */
import { useEffect, useState } from 'react';
import { LayoutTemplate, Star, Users } from 'lucide-react';
import { libraryService } from '../../services/libraryService';
import { personalizationRows } from './libraryModel';

const ICONS = { marca: Star, reparto: Users, plantilla: LayoutTemplate };

export default function ProjectPersonalization({ projectId, onPick }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    setData(null);
    if (!projectId) return undefined;
    libraryService.personalization(projectId)
      .then((d) => { if (alive) setData(d); })
      .catch(() => { if (alive) setData({}); });
    return () => { alive = false; };
  }, [projectId]);

  if (!projectId) return null;
  const rows = personalizationRows(data || {});
  return (
    <div className="v2-perso" data-testid="project-personalization">
      <div className="v2-menu-head">Personalización del proyecto</div>
      {rows.map((r) => {
        const Icon = ICONS[r.key];
        return (
          <button key={r.key} type="button" role="menuitem" onClick={() => onPick?.(r)} data-testid={`perso-${r.key}`}>
            <Icon size={14} /> {r.label}
            <span className={`v2-perso-value ${r.empty ? 'is-empty' : ''}`}>{data ? r.value : '…'}</span>
          </button>
        );
      })}
    </div>
  );
}
